import Vue from 'vue';
import all from './items';

const success = (response, resolve) => {
  all(1, 5);
  resolve(response);
};

const failed = (error, reject) => {
  reject(error);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/purchases/${id}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/destroy.js